document.addEventListener("DOMContentLoaded", function () {
  const swiper = new Swiper(".tagSwiper", {
    slidesPerView: "auto",
    spaceBetween: 4, // default space
    breakpoints: {
      768: {
        spaceBetween: 8,
      },
    },
  });
});
